export default __webpack_public_path__ + "static/media/minus.795a233e.svg";